<div class="survey-page-container objective-survey-page-container">
  <div></div>
  <mat-card appearance="outlined" *ngIf="survey && objectiveAssignment && attendee">
    <mat-card-header>
      <inthraction-profile-image [employeeImage]="attendeeImage"></inthraction-profile-image>
      <div class="employee-info">
        <mat-card-title>{{attendee.firstName}}&nbsp;{{attendee.lastName}}</mat-card-title>
        <mat-card-title *ngIf="objectiveAssignment.objectiveType != 'QUANTIFIABLE'">{{objectiveAssignment.orgObjective.objective.display}}</mat-card-title>
        <mat-card-subtitle *ngIf=" objectiveAssignment.objectiveType != 'QUANTIFIABLE'">{{objectiveAssignment.orgObjective.objective.definition}}</mat-card-subtitle>
        <mat-card-subtitle *ngIf="objectiveAssignment.objectiveType != 'QUANTIFIABLE' && objectiveAssignment.orgObjective.businessObjective">{{objectiveAssignment.orgObjective.businessObjective}}</mat-card-subtitle>
        <mat-card-subtitle *ngIf="objectiveAssignment.objectiveType != 'QUANTIFIABLE' && objectiveAssignment.managerDescription">{{objectiveAssignment.managerDescription}}</mat-card-subtitle>
        <mat-card-title *ngIf="objectiveAssignment.objectiveType == 'QUANTIFIABLE'">{{objectiveAssignment.title}}</mat-card-title>
        <mat-card-subtitle *ngIf="objectiveAssignment.objectiveType == 'QUANTIFIABLE'">{{objectiveAssignment.managerDescription}}</mat-card-subtitle>
      </div>
    </mat-card-header>
    <form (ngSubmit)="submitSurvey(surveyForm.value, submitButtonElement)" [formGroup]="surveyForm" autocomplete="off" novalidate>
      <mat-card-content>
        <div *ngIf="objectiveAssignment.objectiveType != 'QUANTIFIABLE' && objectiveAssignment.orgObjective.objective.observables && objectiveAssignment.orgObjective.objective.observables.length > 0" class="observables-wrapper">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Observables</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
              <ul class="objectiveObservables">
                <li *ngFor="let observable of objectiveAssignment.orgObjective.objective.observables">{{observable}}</li>
              </ul>
            </mat-panel-description>
          </mat-expansion-panel>
        </div>
        <div class="survey-container">
          <label id="survey-radio-group-label">
            <span *ngIf="objectiveAssignment.objectiveType == 'DEFINED'">You have had several intHRactions with {{attendee.firstName}}.  Based on your intHRaction with {{attendee.firstName}}, please provide feedback on the objective "{{objectiveAssignment.orgObjective.objective.display}}".</span>
            <span *ngIf="objectiveAssignment.objectiveType == 'DEFINED_MANAGER'">Based on your observations of {{attendee.firstName}} as their manager, how are they progressing with the objective "{{objectiveAssignment.orgObjective.objective.display}}"?</span>
            <span *ngIf="objectiveAssignment.objectiveType == 'DEFINED_SELF'">You have been asked to rate yourself on the objective "{{objectiveAssignment.orgObjective.objective.display}}". How are you progressing with this objective?</span>
            <span *ngIf="objectiveAssignment.objectiveType == 'QUANTIFIABLE'">You have asked {{attendee.firstName}} to meet this objective with a quantity of {{objectiveAssignment.quantity}}. How is {{attendee.firstName}} progressing with the objective "{{objectiveAssignment.title}}".</span>
          </label>
          <div class="survey-group">
            <ng-container *ngFor="let id of objectiveSurveyResponseTypes">
              <div id="{{id}}-btn" (click)="surveyValue.setValue(objectiveSurveyResponseValues[id])"
                   [className]="surveyValue.value === objectiveSurveyResponseValues[id] ? 'selected':''"
                   [matTooltipShowDelay]="500" [matTooltipPosition]="'left'"
                   matTooltip="{{objectiveSurveyResponseTips[id]}}">
                <button mat-mini-fab id="{{id}}-icon" type="button">
                  <mat-icon svgIcon="{{objectiveSurveyResponseIcons[id]}}"></mat-icon>
                </button>
                <span>{{objectiveSurveyResponseLabels[id] + (objectiveSurveyResponseValues[id] === 1 || objectiveSurveyResponseValues[id] === 5 ? ' (Feedback Required)' : '')}}</span>
              </div>
            </ng-container>
          </div>
          <mat-form-field class="full-width">
            <mat-label>Feedback</mat-label>
            <textarea matInput formControlName="feedback" id="feedback" maxlength="500" name="Feedback" rows="3"></textarea>
            <mat-error *ngIf="hasError('feedback', 'required')">Feedback is required</mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button #submitButtonElement [disabled]="!surveyForm.valid" color="primary" mat-raised-button type="submit">Submit</button>
      </mat-card-actions>
    </form>
    <mat-card-content class="footer">
      <span class="btm-cnr-right">1 of {{remainingSurveysCount}}</span>
      <mat-card-subtitle>Your name and comments are only shared with this individuals Manager and Human Resources. Any information provided is intended to aid in the constructive development of our Workforce.</mat-card-subtitle>
    </mat-card-content>
  </mat-card>
  <div></div>
</div>
